import { FORBIDDEN_STATUS } from '@/services/types/errors/mockForbiddenError'
import { type AppError } from '../../classes/AppError'

export function isForbiddenError(error: AppError): boolean {
  return error.status === FORBIDDEN_STATUS
}
